<template>
  <div v-if="!loggedIn">
    <div class="auth">
      <div class="auth-overlay" style="display: block"></div>
      <div class="d-flex align-center-option min-vh-100 py-3 py-md-0">
        <div class="container auth-container">
          <div class="auth-card">
            <div class="row no-gutters">
              <div class="col-md-5 m-0">
                <!--<div class="auth-card-overlay"></div>-->
                <img
                  src="../assets/img/login.jpg"
                  alt="login"
                  class="auth-card-img"
                />
              </div>
              <div class="col-md-7">
                <div class="card-body" id="reg-card">
                  <a href="https://www.freedom-vrn.ru">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Закрыть"
                    ></button>
                  </a>
                  <div class="brand-wrapper mb-2">
                    <div class="logo d-block"></div>
                    <div class="mr-4 logo-swift"></div>
                  </div>

                  <div class="h3-rem mb-3">
                    Личный кабинет для юридических лиц
                  </div>

                  <form class="login" @submit.prevent="login">
                    <div class="input-group mb-4">
                      <input
                        v-model="inn"
                        type="text"
                        class="form-control input-text"
                        v-maska
                        data-maska="############"
                        placeholder="ИНН (необязательно)"
                        maxlength="12"
                        minlength="10"
                      />
                    </div>
                    <!-- <div class="input-group mb-4">
                      <input
                        v-model="passport"
                        type="text"
                        class="form-control input-text"
                        v-maska
                        data-maska="#### ######"
                        placeholder="Паспортные данные (необязательно)"
                        maxlength="11"
                        minlength="11"
                      />
                    </div> -->
                    <div class="input-group mb-4">
                      <input
                        v-model="phoneNumber"
                        type="text"
                        class="form-control input-text"
                        v-maska
                        data-maska="['+7 (###) ##-##-##', '+7 (###) ###-##-##']"
                        placeholder="номер телефона"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="email"
                        type="text"
                        class="form-control input-text"
                        placeholder="email из договора"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="login"
                        type="text"
                        class="form-control input-text"
                        placeholder="учетное имя (необязательно)"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="contractNumber"
                        type="text"
                        class="form-control input-text"
                        placeholder="номер договора (необязательно)"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="clientName"
                        required
                        type="text"
                        class="form-control input-text"
                        placeholder="название организации или ИП"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="name"
                        type="text"
                        class="form-control input-text"
                        placeholder="Ваше имя (как к Вам обращаться)"
                        required
                        maxlength="100"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <textarea
                        v-model="comments"
                        class="form-control input-text"
                        placeholder="комментарии (необязательно)"
                      ></textarea>
                    </div>
                    <div class="input-group mb-4">
                      <div
                        class="d-flex align-items-center"
                        style="min-width: 350px"
                      >
                        <div>
                          <input
                            type="checkbox"
                            id="agreement"
                            v-model="agree"
                            class="checkbox-box"
                          />
                          <label for="agreement"></label>
                        </div>

                        <div class="ml-2">
                          <label for="agreement">
                            Согласен на обработку
                            <a
                              href="https://freedom-vrn.ru/static/docs/politics.pdf"
                              target="_blank"
                              >персональных данных</a
                            ></label
                          >
                        </div>
                      </div>
                    </div>

                    <button
                      @click="register"
                      class="btn btn-green"
                      :disabled="isSending || !agree"
                    >
                      Отправить
                    </button>
                    <lk-button
                      class="mt-4"
                      color="blue"
                      @click="() => router.push('/login')"
                      >Войти</lk-button
                    >
                    <!-- submit нужен для отправки формы по enter -->
                    <input type="submit" style="display: none" />
                  </form>

                  <div
                    v-if="message"
                    class="mt-3"
                    :class="registerSuccess ? 'green' : 'warning'"
                  >
                    {{ message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { vMaska } from "maska";
import { useRouter } from "vue-router";

export default {
  data() {
    return {
      login: "",
      contractNumber: "",
      clientName: "",
      name: "",
      phoneNumber: "+7 (",
      email: "",
      comments: "",
      inn: "",
      /*passport: "",*/
      message: null,
      router: useRouter(),
      isSending: false,
      agree: false,
    };
  },
  directives: { maska: vMaska },
  mounted() {
    if (this.loggedIn) {
      this.$router.go(-1);
    }
  },
  watch: {
    login() {
      this.message = null;
    },
    contractNumber() {
      this.message = null;
    },
    clientName() {
      this.message = null;
    },
    name() {
      this.message = null;
    },
    phoneNumber() {
      this.message = null;
    },
    email() {
      this.message = null;
    },
    comments() {
      this.message = null;
    },
    inn() {
      this.message = null;
    },
    passport() {
      this.message = null;
    },
  },
  computed: {
    ...mapState(["registerSuccess", "registerError"]),
    ...mapGetters(["loggedIn"]),
  },
  methods: {
    ...mapActions(["sendRegister"]),
    ...mapMutations(["setRegisterSuccess"]),

    validateEmail() {
      return /^$|^[a-za-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
        this.email
      );
    },

    validatePhone(number) {
      return /(7|8)\d{9}|\d{10}/.test(number);
    },

    validateInn() {
      return /\d{10,12}/.test(this.inn);
    },

    validateFIO() {
      return this.name.length < 100;
    },

    /*validatePassport() {
      return /^\d{4}\s?\d{6}$/.test(this.passport);
    },*/

    register() {
      if (this.isSending) {
        return;
      }
      this.setRegisterSuccess(false);
      let login = this.login.trim();
      let contractNumber = this.contractNumber.trim();
      let clientName = this.clientName.trim();
      let comments = this.comments.trim();
      let inn = this.inn.trim().toLowerCase();
      //let passport = this.passport.trim().replace(/\s+/g, '');
      let name = this.name.trim();
      let phoneNumber = this.phoneNumber.trim().replaceAll(/[- )(+]/g, "");
      let email = this.email.trim();

      if (inn.length > 0) {
        if (!this.validateInn()) {
          this.message = "Укажите, пожалуйста, корректный ИНН";
          return;
        }
      }
      // if (passport.length > 0) {
      //   if (!this.validatePassport()) {
      //     this.message = "Укажите, пожалуйста, корректные паспортные данные";
      //     return;
      //   }
      // }
      // if (!inn && !passport) {
      //   this.message = "Укажите, пожалуйста, ИНН или паспортные данные";
      //   this.message = "Укажите, пожалуйста, ИНН";
      //   return;
      // }
      if (!name) {
        this.message = "ФИО не указано";
        return;
      }
      if (!clientName) {
        this.message = "Название организации или ИП не указано";
        return;
      }
      {
        if (!this.validateFIO()) {
          this.message = "Укажите, пожалуйста, корректное ФИО";
          return;
        }
      }
      if (phoneNumber.length < 2 && !email) {
        this.message = "Укажите, пожалуйста, контактный телефон или email";
        return;
      }
      // if (!phone) {
      //   this.message = "Контактный телефон не указан";
      //   return;
      // } else {
      if (phoneNumber.length > 1) {
        if (!this.validatePhone(phoneNumber)) {
          this.message = "Укажите, пожалуйста, корректный номер телефона";
          return;
        }
      }
      // if (!email) {
      //   this.message = "Контактный email не указан";
      //   return;
      // } else {
      if (email.length > 0) {
        if (!this.validateEmail()) {
          this.message = "Укажите, пожалуйста, корректный email";
          return;
        }
      }
      if (!this.agree) {
        this.message =
          "Необходимо Ваше согласие на обработку персональных данных";
        return;
      }
      this.sendRegister({
        inn,
        /*passport,*/
        name,
        phoneNumber,
        email,
        clientName,
        login,
        contractNumber,
        comments,
      }).then(() => {
        if (this.registerSuccess) {
          this.message = "Заявка на регистрацию в личном кабинете отправлена.";
          this.isSending = true;
        } else {
          this.message = this.registerError;
        }
      });
      this.isSending = true;
    },
  },
};
</script>

<style></style>
